<div id="profile" class="{{pagelayout}}" wtfPerfectScrollbar>
    <div class="top-bg mat-black-bg" style="opacity:0.7"></div>
    <div [ngClass]="{'center':layout === 'carded'}">
        <!-- HEADER -->
        <div class="header p-24" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between end">
            <div class="user-info" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center">



                    <img  class="profile-image avatar huge" (click)="ProfileImageClick()" src="/src/assets/images/ecommerce/product-image-placeholder.png"
                    alt="Default Image Profile"
                     *ngIf="!profileImage" />

                <div class="profile-info">
                    <div class="name">{{profileName}}</div>
                    <mat-chip-list *ngIf="isCustomer == true" class="label-chips">
                        <mat-chip class="mat-chip mat-primary" role="option" tabindex="-1" aria-disabled="false" aria-selected="false">Initial Meeting</mat-chip>
                        <mat-chip class="mat-chip mat-primary mat-chip-selected" color="primary" role="option" selected="true" tabindex="-1"
                            ng-reflect-color="primary" ng-reflect-selected="true" aria-disabled="false" aria-selected="true">Not Started</mat-chip>
                        <mat-chip class="mat-chip mat-accent mat-chip-selected" color="accent" role="option" selected="true" tabindex="-1"
                            ng-reflect-color="accent" ng-reflect-selected="true" aria-disabled="false" aria-selected="true">Commercial</mat-chip>
                    </mat-chip-list>
                </div>
            </div>
            <div class="actions" fxLayout="row" fxLayoutAlign="end center" >
                <ng-content select="button"></ng-content>
            </div>
        </div>
        <!-- / HEADER -->
    <!-- CONTENT [ngClass]="{'content-card mat-white-bg':layout === 'carded', 'content':layout === 'simple'}" -->
    <div class="content">
        <ng-content></ng-content>
    </div>
    <!-- / CONTENT -->
    </div>
</div>
